import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import { LmsAssessmentTeacherAPIServiceV8 } from '@protos/learning_management/lms.assessment.teacher.apis_connect';
import {
  ResponseStatusCodeFunction,
  lmsTransportWithLogoutHandler,
} from './transports';

export const useLmsAssessmentTeacherAPIServiceV8WithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    LmsAssessmentTeacherAPIServiceV8,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
